import { render } from "./SaleChannelDetail.vue?vue&type=template&id=649cb4a4"
import script from "./SaleChannelDetail.vue?vue&type=script&lang=js"
export * from "./SaleChannelDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__